const scrollPageToBottom = () => window.scrollTo(0, document.body.scrollHeight);

export default scrollPageToBottom;
